/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  $(function() {
    var counter = 0,
        defaultCountry = 'IT',
        defaultCountryCode = '+39|' + defaultCountry,
        $formList = $("#form-list"),
        $form = $formList.closest("form"),
        template_block = $('#template-block').html(),
        policyAlert = true;

    $.extend($.validator.messages, {
      required: "Il campo è obbligatorio",
    });
    // Aggiunta del metodo per la validazione del numero di telefono
    $.validator.addMethod("phoneNumber", function(value, element) {
      var $this = $(element),
          $parent = $this.closest(".input-field-container"),
          countryCode = $('.country_code', $parent).val(),
          phoneNumber = new libphonenumber.parsePhoneNumberFromString(countryCode + value);

      try {
        phoneNumber.nationalNumber ? $this.val(phoneNumber.nationalNumber) : null;
        return phoneNumber.isValid();
      } catch (ex) {
        return false;
      }
    }, "* Numero telefonico non valido");

    function add_template_block(remove) {
      var html = _.template(template_block);
      $formList.append(html({
        counter: counter++,
        remove: remove
      }));
      $form.validate({
        ignore: []
      });

      $(".phoneNumber").last().rules("add", {
        phoneNumber: true
      });

      $('.date-formatter').toArray().forEach(function (field) {
        new Cleave(field, {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y']
        });
      });

      // Popolamento tendina paese
      var $country = $('.country').last();
      $country.html('').append('<option value="" selected></option>');
      $.each(COUNTRIES.sort(function(a, b) {
          return a.PAESE > b.PAESE ? 1 : -1
        }), function(key, val) {
        $country.append('<option value="' + val.ISO_3166 + '" data-sel="' + val.CODE + '|' + val.ISO_3166 + '">' + val.PAESE + '</option>');
      });

      // Popolamento tendina country code
      var $country_code = $('.country_code').last();
      $country_code.html('').append('<option value="" selected></option>');
      $.each(COUNTRIES.sort(function(a, b) {
          return a.CODE > b.CODE ? 1 : -1
        }), function(key, val) {
        $country_code.append('<option value="' + val.CODE + '" data-sel="' + val.CODE + '|' + val.ISO_3166 + '">' + val.CODE + ' (' + val.ISO_3166 + ')' + '</option>');
      });

      $country.val(defaultCountry);
      $country_code.find('option').each(function() {
        if ($(this).data('sel') == defaultCountryCode) {
          $(this).prop('selected', true);
        }
      });

      $form.find(".policy-group").last().find("input[type='checkbox']").first().prop('checked', true);

      $('[data-toggle="tooltip"]').tooltip();
    }

    function checkForm($form) {
      var //checkResponse = [],
          $checkedPolicy = $form.find(".policy[type='checkbox']:checked");
          //$policyGrop = $form.find(".policy-group");

      if (policyAlert && $checkedPolicy.length == 0) {
        alert("Ricordati che puoi assicurare la tua vacanza!");
        policyAlert = false;
        return false;
      }

      /* $policyGrop.each(function () {
        $this = $(this);
        $checkedinputPolicy = $(this).find(".policy[type='checkbox']:checked");
        $checkedinputAcceptance = $(this).find("input[id^='insurances_acceptance_']:checked");
        var check = ($checkedinputPolicy.length > 0 && $checkedinputAcceptance.length == 0) ? 'false' : 'true';
        checkResponse.push(check);
      });

      if (checkResponse.indexOf('false') > -1) {
        alert('È necessario accettare l\'informativa per i prodotti assicurativi');
        return false;
      } */

      return true;
    }

    // Inizializzo il blocco form
    if ($("#add_participant_form").length > 0) {
      add_template_block(false);
    }

    // Aggiunta di un nuovo partecipante
    $("#add-participant").on("click", function() {
      add_template_block(true);
    });

    // Rimozione di un partecipante
    $formList.on("click", ".remove", function() {
      $(this).parent().remove();
    });

    // Cambio tendina payer
    $formList.on("change", ".payer", function() {
      var usersData = [];
      $(".input-field-container").each(function() {
        var $this = $(this);
            singleUser = {};
        $this.find(".payer").each(function() {
          var params = $(this).attr("name").match(/\[.*?\]/g);
          var index = params[1].replace('[','').replace(']','');
          singleUser[index] = $(this).val();
        });

        usersData.push(singleUser);
      });

      $(".input-field-container").each(function() {
        var $this = $(this),
            previousValue = $(this)
              .find("select[name$='[paying_contact]']")
              .val();

        $(this)
          .find("select[name$='[paying_contact]']")
          .find("option")
          .remove()
          .end()
          .append($("<option></option>"));


        usersData.forEach(function(user) {
          if (user['email'] !== "" && user['name'] !== "" && user['surname'] !== "") {
            $this.find("select[name$='[paying_contact]']").append(
              $("<option></option>")
                .attr("value", user['email'])
                .text(user['name'] + " " + user['surname'])
            );

            // Resettiamo valore se gia impostato
            if (previousValue === user['email']) {
              $this.find("select[name$='[paying_contact]']").val(previousValue);
            }
          }
        });
      });
    });

    // Cambio tendina country
    $formList.on("change", ".country", function() {
      var $this = $(this),
          $parent = $this.closest(".input-field-container"),
          $country_sel = $(".country", $parent).find('option:selected').data('sel');
      $(".country_code", $parent).find('option').each(function() {
        if ($(this).data('sel') == $country_sel) {
          $(this).prop('selected', true);
        }
      });
    });

    // Submit del form partecipante
    $("#add_participant_form").submit(function(e) {
        e.preventDefault();

        var $form = $(this);
        if ($form.valid() && checkForm($form)) {
          $form.ajaxSubmit({
            dataType: 'json',
            data: {
              action: "add_participant",
              nonce: ajaxConfig.nonce
            },
            success: function(responseText, statusText, xhr) {
              window.location.href = ajaxConfig.thankyoupage;
            },
            error: function() {
              //
            }
          });
        }
      }
    );

    //------------------------------------------------------
    // FORM PAGAMENTI
    //------------------------------------------------------

    // Modifica del campo input file allegati
    $("#payment_form").find("input[type='file']").each(function() {
      $(this).on('change', function() {
        $this = $(this);

        // Svuoto tutti gli input file e resetto la loro label
        $(".input-file-name").html('seleziona il file (in formato .png, .jpg, .pdf)');
        $("input[type='file']").not($this).each(function() {
          $(this).val('');
        });

        // Modifico la label con il nome del file selezionato e flaggo la corrispondente radiobox
        if ($this.val() != '') {
          $this.parent().find('p').first().html($this[0].files[0].name);
          $('.' + $this.attr('id')).attr('checked', true);
        }
      });
    });

    // Svuoto tutti gli input file e resetto la loro label al click del radiobutton
    $("input[name='payment_type']").on('click', function() {
      $this = $(this);
      $(".input-file-name").html('seleziona il file (in formato .png, .jpg, .pdf)');
      $("input[type='file']").not($this).each(function() {
        $(this).val('');
      });
    });

    // Submit form pagamenti
    $("#payment_form").submit(function(evt) {
      evt.preventDefault();
      $(this).validate({
        rules: {
          bank_file: {
            required: function(element) {
              return ($("input[name='payment_type']").is(':checked') && $("input[name='payment_type']:checked").val() == 'bank') ? true : false
            }
          },
          postal_file: {
            required: function(element) {
              return ($("input[name='payment_type']").is(':checked') && $("input[name='payment_type']:checked").val() == 'postal') ? true : false
            }
          }
        }
      });

      if ($(this).valid()) {
        $(this)[0].submit();
      }
    });
  });
})(jQuery); // Fully reference jQuery after this point.
